import * as React from 'react';
import { ReactElement } from 'react';
import GroupsContainer from '../../containers/groups/GroupsContainer';

const Groups = (): ReactElement => {
  return <GroupsContainer />;
};
export default Groups;
